module.exports = __webpack_public_path__ + "static/media/receipt-rejected.d5af949f.svg";